import Splide from '@splidejs/splide';
var Carousel = /** @class */ (function () {
    function Carousel() {
        this.selectors = {
            container: '[data-carousel]',
            arrow: '.splide__arrow',
            centerTo: '[data-carousel-center-to]',
        };
        this.nodeList = {
            containers: document.querySelectorAll(this.selectors.container)
        };
        this.carousels = [];
    }
    Carousel.prototype.init = function (modules) {
        var _this = this;
        this.modules = modules;
        this.nodeList.containers.forEach(function (container) {
            var carousel = new Splide(container, _this.config(container));
            carousel.mount();
            _this.carousels.push(carousel);
            carousel.on('moved', function () { return _this.modules.lazyLoader.update(); });
            window.addEventListener('resize', _this.resize.bind(_this));
        });
    };
    Carousel.prototype.config = function (container) {
        var isMobileOnly = container.dataset.carousel === 'mobile';
        var isDesktopOnly = container.dataset.carousel === 'desktop';
        var perPageDesktop = container.dataset.carouselPerPageDesktop ? parseInt(container.dataset.carouselPerPageDesktop) : 4;
        var autoplay = container.dataset.autoplay;
        var autoplaySpeed = container.dataset.autoplaySpeed;
        var updateOnMove = container.dataset.updateOnMove;
        var pagination = container.dataset.pagination;
        var focus = container.dataset.focus;
        var config = {
            type: 'loop',
            perMove: 1,
            mediaQuery: isDesktopOnly ? 'max' : 'min',
            breakpoints: this.breakpoints(isMobileOnly, isDesktopOnly, perPageDesktop),
            pagination: false
        };
        if (focus == 'center') {
            config.focus = "center";
        }
        if (pagination == "true") {
            config.pagination = true;
        }
        if (autoplay == "true") {
            config.autoplay = true;
            config.speed = autoplaySpeed;
        }
        else {
            config.autoplay = false;
        }
        if (updateOnMove == "true") {
            config.updateOnMove = true;
            config.focus = "center";
        }
        if (perPageDesktop && isDesktopOnly) {
            config.perPage = perPageDesktop;
        }
        if (perPageDesktop && !isDesktopOnly) {
            config.breakpoints['1023'].perPage = perPageDesktop;
        }
        return config;
    };
    Carousel.prototype.arrowFix = function (container) {
        var arrows = container.querySelectorAll(this.selectors.arrow);
        var centerTo = container.querySelector(this.selectors.centerTo);
        if (centerTo && arrows) {
            arrows.forEach(function (arrow) {
                arrow.style.top = "".concat(centerTo.offsetHeight / 2, "px");
            });
        }
    };
    Carousel.prototype.resize = function () {
        var _this = this;
        this.nodeList.containers.forEach(function (container) {
            _this.arrowFix(container);
        });
    };
    Carousel.prototype.breakpoints = function (isMobileOnly, isDesktopOnly, perPageDesktop) {
        if (!isMobileOnly && !isDesktopOnly) {
            return {
                1023: {
                    perPage: perPageDesktop
                }
            };
        }
        return {
            1023: {
                destroy: true
            }
        };
    };
    return Carousel;
}());
export { Carousel };
;
